import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { Partner, Constants } from '../constants';
import { PartnerField } from '../models';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'partner-senderfield-picker',
  templateUrl: './partner-senderfield-picker.component.html'
})
export class PartnerSenderfieldPickerComponent implements OnInit {

  @Input()
  partner: Partner;

  @Input()
  fieldMap: Array<PartnerField>;

  @Input()
  partnerFields: Array<PartnerField>;

  @Input()
  usedFields: Array<PartnerField>;

  @Output('onChange')
  onChange: EventEmitter<Array<PartnerField>> = new EventEmitter<Array<PartnerField>>();

  @Output('onRefreshFields')
  onRefreshFields: EventEmitter<any> = new EventEmitter<any>();

  // partner field drop down component
  ddPartnerFields: any[] = [];
  partnerFieldDDSettings: any = {
    singleSelection: true,
    text: 'Select field',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    maxHeight: 260
  };
  ddPartnerField: any;

  fields: Array<PartnerField>;
  addingField: boolean = false;
  currentPartnerField: PartnerField;
  errorState: boolean = false;

  constructor(private constants: Constants,
    private modalService: BsModalService,
    private partnerService: PartnerService) { }

  ngOnInit() {
    // if there are no fields mapped yet, initialize the array
    if (!this.fieldMap) {
      this.fieldMap = [];
    }

    if (this.partner) {
      this.loadFields();
    }
  }

  /**
   * Listen for changes to the partner value in order to properly refresh fields and re-set state
   * when switching from one partner to another
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.partner && changes.partner.previousValue && changes.partner.previousValue.name) {
      // Refresh state of field map controls when partner changes
      this.addingField = false
      this.currentPartnerField = null;
      this.errorState = false;
      this.loadFields();
    }
    else if (changes.usedFields) {
      // change triggers if usedFields changes across all field map controls - ensure fields can
      // only be selected once
      this.loadFields();
    }
  }

  srFieldChange(field) {

  }

  formValid() {
    if (this.currentPartnerField) {
      return true;
    }
    return false;
  }

  selectPartnerField(field: any) {
    this.currentPartnerField = this.fields.find(f => { return f.id == field.id });
  }

  addField() {
    this.canAddField()
      .then(canAdd => {
        if (canAdd) {
          this.fieldMap.push(this.currentPartnerField);
          this.onChange.emit(this.fieldMap);
          this.loadFields();  // refresh from cache to set usedFields up correctly
          this.addingField = false;
        }
      });

  }

  cancelAddField() {
    this.addingField = false;
    this.currentPartnerField = null;
    this.ddPartnerField = [];
  }

  remove(field: PartnerField) {
    this.fieldMap.splice(this.fieldMap.findIndex(f => { return f.id == field.id }), 1);
    this.loadFields(); // refresh from cache to set usedFields up correctly
    this.onChange.emit(this.fieldMap);
  }

  refreshFields() {
    this.onRefreshFields.emit(null);
  }

  private loadFields() {
    this.errorState = false;
    this.fields = [];
    this.ddPartnerField = [];
    this.ddPartnerFields = [];

    this.partnerFields.forEach(f => {
      // only make the field available if it hasn't been used
      if (this.usedFields.findIndex(uf => { return uf.id == f.id}) < 0 &&
          this.fieldMap.findIndex(uf => { return uf.id == f.id}) < 0) {
        this.fields.push({
          id: f.id,
          name: f.name,
          display: f.display,
          type: f.type ? f.type : 'n/a'
        });

        this.ddPartnerFields.push({
          id: f.id,
          itemName: f.display
        });
      }
    });

    this.fields.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      else {
        return 1;
      }
    });

    this.ddPartnerFields.sort((a, b) => {
      if (a.itemName < b.itemName) {
        return -1;
      }
      else {
        return 1;
      }
    });
  }

  private canAddField(): Promise<any> {
    // stub in case we want to put restrictions on this
    return Promise.resolve(true);
  }
}



// WEBPACK FOOTER //
// ./client/app/global/partner-senderfield-picker/partner-senderfield-picker.component.ts